module.exports = __webpack_public_path__ + "img/dice-two.1f00cbc6.svg";